import { css, SerializedStyles } from '@emotion/react';

export const SVG_ICON_GLOBAL_VARIABLES: SerializedStyles = css`
    :root {
        --icon-size-3xs: 10px;
        --icon-size-2xs: 12px;
        --icon-size-xs: 16px;
        --icon-size-s: 20px;
        --icon-size-m: 24px;
        --icon-size-l: 32px;
        --icon-size-xl: 40px;
        --icon-size-2xl: 48px;
        --icon-size-3xl: 56px;
    }
`;
